import React, { useCallback } from 'react'
import { Container, HiddenInput } from './ToggleSwitch.styles'
import { ToggleSwitchProps } from './ToggleSwitch.types'

export const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
  checked = false,
  onChange,
  disabled = false,
  size = 'medium',
  className,
  style,
  'aria-label': ariaLabel,
  id,
}) => {
  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      if (!disabled && onChange) {
        onChange(event.target.checked)
      }
    },
    [disabled, onChange]
  )

  return (
    <Container
      className={className}
      style={style}
      $checked={checked}
      $size={size}
      $disabled={disabled}
    >
      <HiddenInput
        data-toggle-switch="true"
        id={id}
        type="checkbox"
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
        aria-label={ariaLabel}
      />
    </Container>
  )
}
